<template>
  <chrome />
</template>

<script>
import Chrome from './components/chromes/Chrome';

export default {
  name: 'app',
  components: {
    Chrome,
  },
};
</script>

<style lang="scss">
@import 'assets/styles/app.scss';
</style>

<style>
</style>



// WEBPACK FOOTER //
// App.vue?e0701f46